import { useCallback, useEffect, useState } from "react";

import useService from "../../../../../hooks/useService";
import { getModalHandler } from "../../../Common/Modals/hooks/useModalSingleton";

const formatOptions = (data = []) =>
  data.map((item) => ({
    id: Number(item?.key) || item?.key,
    label: item?.value ?? item?.name ?? item?.label ?? "",
  }));

export default function useProviderParentEntityOptions() {
  const providerRepository = useService("repositories/provider-repository");
  const { openFailureModal } = getModalHandler();
  const [options, setOptions] = useState([]);

  const fetchOptions = useCallback(async () => {
    try {
      const response = await providerRepository.getParentEntityOptions({
        entity_type__category: 3,
      });
      setOptions(formatOptions(response));
    } catch (error) {
      console.error(error);
      openFailureModal(error);
    }
  }, [openFailureModal, providerRepository]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  return { options };
}
